import { render, staticRenderFns } from "./chatForm.vue?vue&type=template&id=35e8b8ba&scoped=true&"
import script from "./chatForm.vue?vue&type=script&lang=js&"
export * from "./chatForm.vue?vue&type=script&lang=js&"
import style0 from "./chatForm.vue?vue&type=style&index=0&id=35e8b8ba&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e8b8ba",
  null
  
)

export default component.exports